import axiosInstance from "../api/axiosInstance";

// GET: Promoter / venue promotion request list
export const fetchPromoterRequests = (params) =>
  axiosInstance.get("/admin/promoterRequestList", { params });

// PATCH/PUT: Approve or reject request
export const updatePromoterRequestStatus = (id, data) =>
  axiosInstance.patch(`/admin/promoterRequestStatus/${id}`, data);

// POST: Get promoter sales/payout summary
export const fetchPromoterSalesPayouts = (promoterId, data) =>
  axiosInstance.post(
    `/admin/promotersalespayouts/promoter/${promoterId}`,
    data
  );

// POST: Get promoter sales/payout transactions
// POST: Get promoter sales/payout transactions
// hostId is sent as a query param only when a venue is selected
// POST: Get promoter sales/payout transactions
// When a venue is selected, hostId is sent in the body and as a query param
export const fetchPromoterSalesPayoutTransactions = (promoterId, data = {}) => {
  const hostId = data?.hostId;
  return axiosInstance.post(
    `/admin/promotersalespayoutstransaction/promoter/${promoterId}`,
    data,
    hostId ? { params: { hostId } } : undefined
  );
};

// POST: Additional bottle service transactions for a promoter
export const fetchAdditionalBottleServiceTransactions = (promoterId, data) =>
  axiosInstance.post(
    `/admin/additionalbottleservicetransaction/promoter/${promoterId}`,
    data
  );

// GET: Promoter bottle sale detail
export const fetchPromoterBottleSaleDetail = (transactionId) =>
  axiosInstance.get(`/admin/promoterBottlesalesdetail/${transactionId}`);

// GET: Promoter joined users list
export const fetchPromoterJoinedUsers = (promoterId, params) =>
  axiosInstance.get(`/admin/promoterjoinedusers/promoter/${promoterId}`, {
    params,
  });

// GET: Promoter venues list
export const fetchPromoterVenues = (promoterId, params) =>
  axiosInstance.get(`/admin/promotervenues/promoter/${promoterId}`, {
    params,
  });
